module.exports = __webpack_public_path__ + "images/interview-Airbnb-2.svg";